import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useContentQuery } from "@/partner/entities/contents";
import { useProductQuery } from "@/partner/entities/products";
import { entityTypeForPath, findSectionItem } from "./pageContext";
import type { EntityType, PageContext } from "./types";

const CONTENT_TYPES = new Set<EntityType>(["STREAM", "VIDEO", "COLLECTION"]);

/**
 * Контекст хода (п. 8 спеки): раздел кабинета и открытая сущность из адреса
 * (?id=, ?tab=edit&id=). Название сущности только из кеша Apollo
 * (cache-only, без сетевого запроса): диалог редактирования уже загрузил
 * её тем же запросом, а нет в кеше, ход уходит без названия.
 */
export function usePageContext(): PageContext {
  const { pathname, search } = useLocation();
  const { t } = useTranslation();
  const id = new URLSearchParams(search).get("id");
  const entityType = id ? entityTypeForPath(pathname) : null;
  const content = useContentQuery({
    variables: { id: id ?? "" },
    skip: !id || !entityType || !CONTENT_TYPES.has(entityType),
    fetchPolicy: "cache-only",
  });
  const product = useProductQuery({
    variables: { id: id ?? "" },
    skip: !id || entityType !== "PRODUCT",
    fetchPolicy: "cache-only",
  });
  const item = findSectionItem(pathname);
  return {
    path: `${pathname}${search}`,
    section: item ? t(item.textKey) : null,
    entityType,
    entityId: id,
    entityTitle:
      content.data?.content?.title ?? product.data?.product?.title ?? null,
  };
}
